import React from "react";
import { Swiper } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import clsx from "clsx/lite";

const CommonSlider = ({ mobile, desktop, children, nav = { next: ".right-arrow-ps", prev: ".left-arrow-ps" }, navClass }) => {
	const shouldShowNavigation = children.length > 2;

	const settings = {
		slidesPerView: mobile || 2,
		slidesPerGroup: mobile || 2,
		preventClicks: true,
		preventClicksPropagation: false,
		simulateTouch: false,
		spaceBetween: 10,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		breakpoints: {
			1024: {
				preventClicks: true,
				preventClicksPropagation: false,
				simulateTouch: false,
				spaceBetween: 30,
				slidesPerView: desktop ?? 4,
				slidesPerGroup: desktop ?? 4,
			},
			768: {
				preventClicks: true,
				preventClicksPropagation: false,
				simulateTouch: false,
				spaceBetween: 30,
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
		},
		navigation: {
			disabledClass: "disabled-arrows",
			enabled: shouldShowNavigation,
			nextEl: nav?.next,
			prevEl: nav?.prev,
		},
	};

	return (
		<>
			<Swiper {...settings}>{children}</Swiper>
			{shouldShowNavigation && (
				<>
					<div className={clsx(nav?.prev.replace(".", ""), navClass)}>
						<LeftArrow role="presentation" aria-hidden="true" />
					</div>
					<div className={clsx(nav?.next.replace(".", ""), navClass)}>
						<RightArrow role="presentation" aria-hidden="true" />
					</div>
				</>
			)}
		</>
	);
};

export default CommonSlider;
